import React, { Component } from 'react';
import WallLocationPicker from '../molecules/WallLocationPicker';
import { wallLocations } from '../utils/index';
import WallNav from '../organisms/WallNav';
import IconClose from '../atoms/IconClose';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import { wallData } from '../utils';

class Wall extends Component {

  constructor( props ) {
    super( props );
    this.state = {
      locationList: [],
      currentLocationIndex: 0,
      currentLocationIndexChangedByNav: false,
      wallHeight: 150,
      wallId: 1,
    }
  }

  updateLocationsList = ( wall, locations ) => {
    this.setState( {
      locationList: wallLocations( wall, locations ),
    } );
  };

  updateWallId = () => {
    const parsed = queryString.parse(this.props.location.search);
    if( parsed.wall ) {
      this.setState({
        wallId: parsed.wall,
      });

      if ( this.props.locations ) {
        this.updateLocationsList( parsed.wall, this.props.locations );
      }
    }
  };

  componentDidMount() {
    this.updateWallId();
  }

  componentDidUpdate( prevProps ) {
    if ( this.props.locations !== prevProps.locations ) {
      this.updateLocationsList( this.state.wallId, this.props.locations );
    }
    if ( this.props.location.search !== prevProps.location.search ) {
      this.updateWallId();
    }
  }

  setIndex = ( i, changedByNav ) => {
    this.setState( {
      currentLocationIndexChangedByNav: changedByNav,
      currentLocationIndex: i,
    } )
  };

  setChangedByNav = ( value ) => {
    this.setState( {
      currentLocationIndexChangedByNav: value,
    } )
  };

  buttonClickHandler = () => {
    this.setState( {
      currentLocationIndex: 0,
    } )
  };

  imageResizeHandler = ( height ) => {
    this.setState( {
      wallHeight: height,
    } )
  };

  render() {
    return (
      <div className="Wall">
        <div className="buttons">
          <Link to="/" onClick={() => { this.buttonClickHandler() }}><IconClose/></Link>
        </div>
        <div className="title">
          <p className="h3">Place Names</p>
          <p className="caps">{wallData( this.state.wallId ).start_letters} &mdash; {wallData( this.state.wallId ).end_letters}</p>
        </div>
        <WallNav
          locationList={this.state.locationList}
          currentLocationIndex={this.state.currentLocationIndex}
          wall={this.state.wallId}
          setIndex={this.setIndex}
          imageResizeHandler={this.imageResizeHandler}
          wallHeight={this.state.wallHeight}/>
        <WallLocationPicker
          locationList={this.state.locationList}
          currentLocationIndex={this.state.currentLocationIndex}
          currentLocationIndexChangedByNav={this.state.currentLocationIndexChangedByNav}
          setIndex={this.setIndex}
          setChangedByNav={this.setChangedByNav}
          wallHeight={this.state.wallHeight}/>
      </div>
    )
  }
}

function mapStateToProps( state ) {
  return {
    locations: state.data.locations,
  };
}

export default connect( mapStateToProps )( Wall );